var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_8884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95455 13.2073C9.46364 13.2073 10.6818 11.9868 10.6818 10.4748C10.6818 8.96279 9.46364 7.74227 7.95455 7.74227C6.44545 7.74227 5.22727 8.96279 5.22727 10.4748C5.22727 11.9868 6.44545 13.2073 7.95455 13.2073ZM7.95455 9.56394C8.45455 9.56394 8.86364 9.97381 8.86364 10.4748C8.86364 10.9757 8.45455 11.3856 7.95455 11.3856C7.45455 11.3856 7.04545 10.9757 7.04545 10.4748C7.04545 9.97381 7.45455 9.56394 7.95455 9.56394ZM18.8636 6.83143H11.5909V14.1181H4.31818V5.00977H2.5V18.6723H4.31818V15.9398H20.6818V18.6723H22.5V10.4748C22.5 8.46183 20.8727 6.83143 18.8636 6.83143ZM20.6818 14.1181H13.4091V8.6531H18.8636C19.8636 8.6531 20.6818 9.47285 20.6818 10.4748V14.1181Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_8884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.046,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/BedIcon.1a0bd89f719358fb5c61835beeb62f59.svg";
export { ForwardRef as ReactComponent };